module.exports = __webpack_public_path__ + "static/img/ssm-logo.8bc652d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssm-logo.png
// module id = 6Sbs
// module chunks = 175